import pageViewGoogleAnalyticsUtil from 'modules/google-analytics/utils/page-view'

function pageViewAnalyticsUtil (pathname) {
  return pageViewGoogleAnalyticsUtil(pathname)
}

export default pageViewAnalyticsUtil
